export class NoPossibilityToPutInstrumentError extends Error {
  private static errorMessage = 'Unable to put instrument ';

  public constructor(private readonly itemName: string) {
    super(NoPossibilityToPutInstrumentError.errorMessage + itemName);
  }
}
